import React from "react";
import "./TestFrame.css";

function TestFrame() {
  return (
    <div className={"testFrame"}>
      <iframe
        title="WVV Karte"
        className="testFrame__embed"
        src="/map"
        width={"900px"}
        height={"700px"}
      />
    </div>
  );
}

export default TestFrame;
